import React from 'react';
import './fileupload.scss';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";

interface IProps {
  onChange?: any,
  noFiles?: boolean,
  file?:any
  multiple?: boolean,
  value?:any,
  title?:any,
  accept?:any
}
const FileUpload = ({ onChange = () => { }, noFiles = true, file = '', multiple = false, value, accept='*', title }: IProps) => {
    const { t } = useTranslation();
    return <div className='file-upload-wrapper'>
        <button className='choose-file'>{title ? title : t(RESOURCE.MyK_Label_ShoppingCart_Select_Files)}</button>
        {(file??"") == "" ?
                <span className='nofile-chosen'>{t(RESOURCE.MyK_Label_ShoppingCart_No_File_Chosen)}</span> :
                 <div className='file-name'>{file?.name}</div>
        }
        <input type="file" value={value} name="myfile" className='file-upload' onChange={onChange} multiple={multiple} accept={accept} />
  </div>
}

export default FileUpload
